<template>
  <div id="kaimgr" class="kaimgr" :style="{'height': height + 'px'}">
    <div class="left">
      <div class="left-box">
        <a :class="mu.home" @click="yiMenu('home')">
          <span>图片管理</span>
        </a>
        <a :class="mu.kaisix" @click="yiMenu('kaisix')" v-if="webid < 4">
          <span>六合开奖</span>
        </a>
        <a :class="mu.kaijnd" @click="yiMenu('kaijnd')" v-if="webid < 4">
          <span>加拿大28开奖</span>
        </a>
        <a :class="mu.kaijndx" @click="yiMenu('kaijndx')" v-if="webid < 4">
          <span>加拿大西28开奖</span>
        </a>
        <a :class="mu.kaibinguo" @click="yiMenu('kaibinguo')" v-if="webid < 4">
          <span>缤果28开奖</span>
        </a>
        <a :class="mu.kaibit" @click="yiMenu('kaibit')" v-if="webid < 4">
          <span>比特币一分28开奖</span>
        </a>
        <!-- <a :class="mu.video" @click="yiMenu('video')">
          <span>视频管理</span>
        </a>
		<a :class="mu.videopassword" @click="yiMenu('videopassword')">
		  <span>视频观看密码</span>
		</a> -->
        <a :class="mu.news" @click="yiMenu('news')">
          <span>新闻公告</span>
        </a>
        <a :class="mu.user" @click="yiMenu('user')">
          <span>账号信息</span>
        </a>
        <a class="set" @click="logout()">
          <span>退出</span>
        </a>
      </div>
    </div>
    <div class="right resetRightWidth">
      <div class="content">
        <el-scrollbar class="page-component__scroll">
          <router-view />
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "kaimgr",
  data() {
    return {
      height: 0,
      menuname: {
        user: '账号信息',
        home: '图片管理',
        kaisix: '六合开奖',
        kaijnd: '加拿大28开奖',
        kaijndx: '加拿大西28开奖',
        kaibinguo: '缤果28开奖',
        kaibit: '比特币一分28开奖',
        cate: '彩票分类',
        lotto: '彩票管理',
        keep: '默认收藏',
        six: '六合预测',
        news: '新闻公告',
        video: '视频管理',
		videopassword: '视频观看密码',
        admin: '账号管理'
      },
      titleText: "",
      erMenuActive_1: "on",
      menu: {
        user: '/kaimgr/user',
        home: '/kaimgr/home',
        cate: '/kaimgr/cate',
        lotto: '/kaimgr/lotto',
        keep: '/kaimgr/keep',
        six: '/kaimgr/six',
        kaisix: '/kaimgr/kaisix',
        kaijnd: '/kaimgr/kaijnd',
        kaijndx: '/kaimgr/kaijndx',
        kaibinguo: '/kaimgr/kaibinguo',
        kaibit: '/kaimgr/kaibit',
        news: '/kaimgr/news',
        video: '/kaimgr/video',
		videopassword: '/kaimgr/videopassword',
        admin: '/kaimgr/admin'
      },
      mu: {
        user: '',
        home: '',
        cate: '',
        lotto: '',
        keep: '',
        six: '',
        kaisix: '',
        kaijnd: '',
        kaijndx: '',
        kaibinguo: '',
        kaibit: '',
        news: '',
        video: '',
		videopassword: '',
        admin: ''
      },
      webid: 0,
      isshowadmin: false
    };
  },
  watch: {
  },
  computed: {},
  mounted() {
    let _this = this;
	this.webid = localStorage.webid
    this.height =
      window.innerHeight ||
      window.screen.availHeight ||
      document.body.clientHeight;
      window.onresize = function() {
        _this.height =
        window.innerHeight ||
        window.screen.availHeight ||
        document.body.clientHeight;
      };
    if (localStorage.menukey) {
      this.yiMenu(localStorage.menukey)
    } else {
      this.yiMenu('home')
    }
  },
  methods: {
    open() {
      this.$confirm("是否退出系统?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.setCookie("access_token", "", "/")
          this.$router.push({ name: "login" })
        })
        .catch(() => {});
    },
    yiMenu (key) {
      let path = this.menu[key]
      this.setMenu(key)
      this.$router.push(path)
    },
    setMenu(key) {
      this.mu = {
        user: '',
        home: '',
        cate: '',
        lotto: '',
        keep: '',
        six: '',
        kaisix: '',
        kaijnd: '',
        kaijndx: '',
        kaibinguo: '',
        kaibit: '',
        news: '',
        video: '',
		videopassword: '',
        admin: ''
      }
      this.mu[key] = 'is-active'
      localStorage.menukey = key
      this.titleText = this.menuname[key]
    },
    logout () {
      localStorage.loginAccount = ''
      localStorage.access_token = ''
      localStorage.webid = ''
      this.$router.push({ name: 'login'})
    }
  }
}
</script>
<style scoped lang="scss">
#kaimgr {
  width: 100%;
  height: 100%;
  position: relative;
  a:hover {
    color: #458afe !important;
  }
  .left {
    display: inline-block;
    vertical-align: top;
    width: 1.5rem;
    height: 100%;
    overflow-y: auto;
    background-color: #1a1e22;
    padding-top: 0.2rem;
    a {
      height: 0.25rem;
      text-align: left;
      line-height: 100%;
      padding-top: 0.05rem;
      padding-left: 0.1rem;
      display: block;
      cursor: pointer;
      i {
        height: 0.3rem;
        line-height: 0.3rem;
        font-size: 0.2rem;
        display: block;
      }
      span {
        color: #8d8f91;
        font-size: 0.116rem;
        line-height: 0.2rem;
      }
    }
    .set {
      position: fixed;
      bottom: 0.25rem;
      width: 0.75rem;
      height: 0.5rem;
      text-align: left;
      padding-top: 0.22rem;
      padding-left: 0.22rem;
      span {
        color: #fff;
      }
    }
    a.is-active,
    a:hover,
    a.is-active span,
    a:hover span {
      background-color: #444 !important;
      color: #fff !important;
    }
    a:hover i {
      color: #fff !important;
    }
  }
  .right {
    position: relative;
    display: inline-block;
    vertical-align: top;
    height: 100%;
    width: calc(100% - 1.5rem);
    .content {
      width: 100%;
      height: 100%;
      overflow: hidden;
      padding-top: 0.02rem;
      box-sizing: border-box;
      background-color: #f3f3f3;
      .page-component__scroll {
        height: 100%;
      }
      .page-scrollbar__wrap {
        overflow: auto;
      }
    }
  }
  .resetRightWidth {
    width: calc(100% - 1.5rem);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/kaimgr.vue